export const getColorByPercentage = (value: number, max: number): string => {
    const percentage = (value / max) * 100;

    if (percentage <= 20) return 'crimson';
    if (percentage <= 40) return 'darkorange';
    if (percentage <= 60) return 'orange';
    if (percentage <= 80) return '#9ACD32';
    return 'limegreen';
};
